<template>
  <RegistrationLayout>
    <div v-if="!brand_loading" class="initial-registration__text">
      <p>「{{ brand.name }}」の連携が完了しました。</p>
    </div>
    <div class="initial-registration__completed">
      <p>
        <img :src="imgIconDownArrow">
      </p>
      <p class="c-cover-img">
        <img :src="coverImg">
      </p>
      <div class="c-button c-button--center">
        <!-- 敢えて同期遷移 -->
        <a class="c-button__item c-button__item--outline-primary"
           :href="`/s/companies/${ currentCompanyUuid }/dashboards`"
        >
          利用開始
        </a>
      </div>
    </div>
  </RegistrationLayout>
</template>

<script>
import RegistrationLayout from '../layouts/RegistrationLayout'
import ImgIconDownArrow from '../../../images/common/icon_down_arrow.svg'
import {mapActions, mapState} from 'vuex'
import CoverImg from '../../../images/common/cover_image.png'

export default {
  name: 'RegistrationsCompleted',
  components: {
    RegistrationLayout,
  },
  data() {
    return {
      coverImg: CoverImg,
      imgIconDownArrow: ImgIconDownArrow,
      intervalId: null,
    }
  },
  computed: {
    ...mapState({
      brand: state => state.companiesRegistrationsBrand.brand,
      brand_loading: state => state.companiesRegistrationsBrand.loading,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
  },

  async created() {
    await this.readBrand(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readBrand: 'companiesRegistrationsBrand/readRegistrationsBrand',
    }),
  },
}
</script>

<style lang="scss" scoped>
.initial-registration__completed {
  margin: 64px auto 0;
  max-width: 512px;
}
.c-cover-img {
  margin: 0 auto;
  max-width: 367px;
}
</style>
